import type { AttachmentData, AttachmentMediaCategory } from './types'

export function getMediaCategory(
  data: AttachmentData
): AttachmentMediaCategory {
  if (data.type === 'source') {
    return 'source'
  }

  const mediaType = data.mediaType || ''

  if (mediaType.startsWith('image/')) return 'image'
  if (mediaType.startsWith('video/')) return 'video'
  if (mediaType.startsWith('audio/')) return 'audio'
  if (
    mediaType.includes('pdf') ||
    mediaType.includes('document') ||
    mediaType.includes('text') ||
    mediaType.includes('sheet') ||
    mediaType.includes('presentation')
  ) {
    return 'document'
  }

  return 'unknown'
}

export function getAttachmentLabel(data: AttachmentData) {
  if (data.type === 'source') {
    return data.title || data.filename || data.url || 'Source'
  }

  return data.filename || 'Attachment'
}
